/* @format */

import { api } from '@/scripts/api';

export const RegisteredDealService = {
    /**
     * Get registered deals based on the query options.
     *
     * @param {import('odata-query').QueryOptions<any>} queryOptions
     */
    async getRegisteredDeals(queryOptions) {
        const query = api.buildODataQuery(queryOptions);
        const endpoint = `/service/RegisteredDeals${query}`;
        return api.get(endpoint);
    },

    /**
     * Get a registered deal by ID.
     *
     * @param {number} id - The registered deal ID
     * @param {import('odata-query').QueryOptions<any>} [queryOptions] - Optional query options
     */
    async getRegisteredDealById(id, queryOptions) {
        return this.getRegisteredDeals({
            ...(queryOptions ?? {}),
            filter: {
                ...(queryOptions?.filter ?? {}),
                Id: id,
            },
        });
    },

    /**
     * Create a new registered deal.
     *
     * @param {Object} registeredDealDto
     */
    async postRegisteredDeal(registeredDealDto) {
        return api.post('/api/RegisteredDeals', registeredDealDto);
    },

    /**
     * Update a registered deal.
     *
     * @param {number} id
     * @param {Object} registeredDealChanges
     */
    async patchRegisteredDeal(id, registeredDealChanges) {
        return api.patch(`/api/RegisteredDeals/${id}`, registeredDealChanges);
    },
};
